import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RegistrationForm from 'components/authentication/RegistrationForm';
import { titler } from 'helpers/titler';

const Registration = () => {
  titler('Registrazione');
  return (
    <>
      <Row className="align-items-center mb-2">
        <Col>
          <h5 id="modalLabel">Iscriviti</h5>
        </Col>
        <Col xs="auto">
          <p className="fs-10 text-600 mb-0">
            Hai già un account? <Link to="/login">Login</Link>
          </p>
        </Col>
      </Row>
      <RegistrationForm />
    </>
  );
};

export default Registration;
